import { ComponentMessageMediaVO, MediaTypeVO } from '@repo/types'
import React, { MutableRefObject, ReactNode } from 'react'
import {
  DropdownActionProps,
  InputUploadButton,
  inputUploadVariants,
  Loading,
  useUploadButton
} from '@web/modules/core'
import { Button, ButtonProps, Tooltip } from '@tecsinapse/cortex-react'
import MediaTypeIcon from '@web/modules/core/components/MediaTypeIcon'
import { MdInsertDriveFile, MdOutlineClose } from 'react-icons/md'

interface UploadFieldProps {
  textInputRef?: MutableRefObject<HTMLTextAreaElement | null>
  currentFile?: ComponentMessageMediaVO
  mediaTypes: MediaTypeVO[]
  connectionKey: string
  handleUpload: (medias: ComponentMessageMediaVO[]) => void
  handleCancelUpload?: () => void
  label?: string
  icon: ReactNode
  buttonVariants?: ButtonProps['variants']
  showMediaChip: boolean
  additionalActions?: DropdownActionProps[]
  disabled?: boolean
  multiple?: boolean
  onlyIcon?: boolean
  stompDisconnected?: boolean | undefined
}

const { iconAndButton, blank, buttonRemoveMedia } = inputUploadVariants()

const InputUpload = ({
  textInputRef,
  currentFile,
  mediaTypes,
  connectionKey,
  handleUpload,
  handleCancelUpload,
  label,
  disabled,
  icon,
  buttonVariants,
  showMediaChip,
  additionalActions,
  multiple = false,
  onlyIcon = false,
  stompDisconnected
}: UploadFieldProps) => {
  const {
    files,
    isUploading,
    handleUploadButton,
    handleRemoveMedia,
    buttonRef,
    handleMediaOptionUpload,
    handleUploadFiles,
    controller
  } = useUploadButton({
    textInputRef,
    currentFile,
    handleUpload,
    handleCancelUpload,
    connectionKey
  })

  const actions: DropdownActionProps[] = mediaTypes.map(value => {
    const ref = buttonRef(value.ref)
    return {
      label: value.label,
      onClick: () => handleMediaOptionUpload(ref),
      icon: <MediaTypeIcon mediaType={value.icon} />,
      children: (
        <input
          ref={ref}
          accept={value.acceptedFormats}
          type='file'
          onChange={e => handleUploadFiles(e.target.files)}
          multiple={multiple}
          hidden
        />
      )
    }
  })

  additionalActions?.forEach(it => actions.push(it))

  return (
    <>
      {showMediaChip && files.length === 1 ? (
        <div className={iconAndButton()}>
          <MdInsertDriveFile className={'text-deca text-dark'} />
          <a
            className={blank()}
            href={files[0].url}
            target={'_blank'}
            rel='noreferrer'
          >
            <p className='text-mili'>{files[0].name.substring(0, 28)}...</p>
          </a>
          <Button
            className={buttonRemoveMedia()}
            onClick={handleRemoveMedia}
          >
            <MdOutlineClose className={'text-centi text-dark'} />
          </Button>
        </div>
      ) : (
        <div>
          {!isUploading ? (
            <>
              {stompDisconnected ? (
                <Tooltip text='Envio desabilitado.'>
                  <div className='text-secondary-medium'>{icon}</div>
                </Tooltip>
              ) : (
                <InputUploadButton
                  label={label}
                  buttonVariants={buttonVariants}
                  disabled={disabled}
                  isUploading={isUploading}
                  icon={icon}
                  onlyIcon={onlyIcon}
                  controller={controller}
                  actions={actions}
                  handleUploadButton={handleUploadButton}
                />
              )}
            </>
          ) : (
            <Loading />
          )}
        </div>
      )}
    </>
  )
}

export default InputUpload
